import {
  SET_UTM_ORIGIN,
  SET_AT_UNIT,
  SET_TEAM_NAME,
  SET_FLOW_STEPS,
  SET_T2_FLOW,
  SET_PAYMENT_BYPASS,
  SET_VACCINE_FLOW,
  SET_COLLABORATOR_FLOW,
  SET_IS_NAV,
  SET_ALTERNATIVE_MESSAGE_DATA,
  SET_IS_SCHEDULED_ADMISSION,
  SET_HAS_SURVEY,
  SET_ONLINE_PAYMENT_ENABLED,
  SET_HOUR_ADMISSION_WITHOUT_SCHEDULING,
  SET_ADMISSION_FLOWS,
  SET_AMIL_TOKENS_TO_VALIDATE,
  SET_IS_INCOMPANY_FLOW,
} from './mutation-types';
import { getInitialState } from './state';

const mutations = {
  SET_CLEAR_GLOBAL(state) {
    Object.assign(state, getInitialState());
  },
  SET_ADMISSION_AUTHORIZATION(state, isAuthorized) {
    state.isAdmissionAuthorized = isAuthorized;
  },

  SET_START_FLOW_PAYMENT_CHOICE(state, isFlowStartedWithPaymentChoice) {
    state.isFlowStartedWithPaymentChoice = isFlowStartedWithPaymentChoice;
  },

  [SET_AMIL_TOKENS_TO_VALIDATE](state, amilTokensToValidate) {
    state.amilTokensToValidate = amilTokensToValidate;
  },

  [SET_UTM_ORIGIN](state, utmOrigin) {
    state.utmOrigin = utmOrigin;
  },

  [SET_AT_UNIT](state, atUnit) {
    state.atUnit = atUnit;
  },

  [SET_TEAM_NAME](state, teamName) {
    state.teamName = teamName;
  },

  [SET_FLOW_STEPS](state, flowSteps) {
    state.flowSteps = flowSteps;
  },

  [SET_T2_FLOW](state, data) {
    state.isT2FlowAllowed = data;
  },

  [SET_ADMISSION_FLOWS](state, data) {
    state.admissionFlows = data;
  },

  [SET_IS_INCOMPANY_FLOW](state, data) {
    state.admissionFlows.isInCompanyFlow = data;
  },

  [SET_PAYMENT_BYPASS](state, data) {
    state.isElegibleToBypassToPayment = data;
  },

  [SET_VACCINE_FLOW](state, data) {
    state.isVaccineFlow = data;
  },

  [SET_COLLABORATOR_FLOW](state, data) {
    state.isCollaboratorFlow = data;
  },
  [SET_IS_NAV](state, data) {
    state.isNav = data;
  },

  [SET_ALTERNATIVE_MESSAGE_DATA](state, data) {
    state.alternativeMessageData = data;
  },

  [SET_IS_SCHEDULED_ADMISSION](state, data) {
    state.isScheduledAdmission = data;
  },

  [SET_HAS_SURVEY](state, data) {
    state.hasSurvey = data;
  },

  CLEAR_ALTERNATIVE_MESSAGE_DATA(state) {
    state.alternativeMessageData = null;
  },

  [SET_ONLINE_PAYMENT_ENABLED](state, isEnabled) {
    state.isOnlinePaymentEnabled = isEnabled;
  },

  [SET_HOUR_ADMISSION_WITHOUT_SCHEDULING](state, hour) {
    state.hourAdmissionWithoutScheduling = hour;
  },

  SET_END_FLOW_MESSAGE_BY_FLOW(state, endFlowMessageByFlow) {
    state.endFlowMessageByFlow = endFlowMessageByFlow;
  },

  SET_SKIP_SERVICE_DESK_FLOW_FAIL(state, skipServiceDeskFlowFail) {
    state.skipServiceDeskFlowFail = skipServiceDeskFlowFail;
  },
  SET_SERVICES_CHANGE(state, flag) {
    state.servicesChange = flag;
  },

  SET_BUTTON_CONFIRM_ARRIVAL(state, confirm) {
    state.buttonConfirmArrival = confirm;
  },

  SET_LIST_CATEGORY_EXAMS(state, list) {
    state.listCategoryExams = list;
  },

  SET_USER_CHECKIN_ORIGIN(state, origin) {
    state.userCheckinOrigin = origin;
  },

  SET_BRADESCO_FLOW(state, data) {
    state.isBradescoFlowSuccess = data;
  },
};

export default mutations;
